import React from 'react';
import { Crown, Facebook, Instagram, Twitter, Mail, Phone, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-forest-dark text-cream/80 pt-20 pb-10" data-id="element-34">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-35">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-36">
          {/* Brand */}
          <div className="space-y-6" data-id="element-37">
            <div className="flex items-center gap-2" data-id="element-38">
              <div className="bg-gold p-1.5 rounded-full text-white" data-id="element-39">
                <Crown size={20} fill="currentColor" data-id="element-40" />
              </div>
              <div className="flex flex-col" data-id="element-41">
                <span className="font-serif font-bold text-lg leading-none text-white" data-id="element-42">
                  sgbeautycastle
                </span>
              </div>
            </div>
            <p className="text-sm leading-relaxed text-cream/60" data-id="element-43">
              Singapore's premier platform for discovering and booking the
              finest massage and spa experiences. Trusted by thousands since
              2018.
            </p>
            <div className="flex gap-4" data-id="element-44">
              <a href="#" className="hover:text-gold transition-colors" data-id="element-45">
                <Instagram size={20} data-id="element-46" />
              </a>
              <a href="#" className="hover:text-gold transition-colors" data-id="element-47">
                <Facebook size={20} data-id="element-48" />
              </a>
              <a href="#" className="hover:text-gold transition-colors" data-id="element-49">
                <Twitter size={20} data-id="element-50" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-51">
            <h4 className="text-white font-serif font-bold text-lg mb-6" data-id="element-52">
              Quick Links
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-53">
              <li data-id="element-54">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-55">
                  About Us
                </a>
              </li>
              <li data-id="element-56">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-57">
                  Featured Shops
                </a>
              </li>
              <li data-id="element-58">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-59">
                  Partner With Us
                </a>
              </li>
              <li data-id="element-60">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-61">
                  Blog
                </a>
              </li>
              <li data-id="element-62">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-63">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-64">
            <h4 className="text-white font-serif font-bold text-lg mb-6" data-id="element-65">
              Services
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-66">
              <li data-id="element-67">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-68">
                  Traditional Chinese Massage
                </a>
              </li>
              <li data-id="element-69">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-70">
                  Thai Massage
                </a>
              </li>
              <li data-id="element-71">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-72">
                  Foot Reflexology
                </a>
              </li>
              <li data-id="element-73">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-74">
                  Aromatherapy SPA
                </a>
              </li>
              <li data-id="element-75">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-76">
                  Couples Massage
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-77">
            <h4 className="text-white font-serif font-bold text-lg mb-6" data-id="element-78">
              Contact Us
            </h4>
            <ul className="space-y-4 text-sm" data-id="element-79">
              <li className="flex items-start gap-3" data-id="element-80">
                <MapPin size={18} className="text-gold mt-0.5" data-id="element-81" />
                <span data-id="element-82">
                  10 Anson Road, #20-15 International Plaza, Singapore 079903
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-83">
                <Phone size={18} className="text-gold" data-id="element-84" />
                <span data-id="element-85">+65 6789 1234</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-86">
                <Mail size={18} className="text-gold" data-id="element-87" />
                <span data-id="element-88">hello@beautycastle.sg</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-cream/40" data-id="element-89">
          <p data-id="element-90">© 2026 sgbeautycastle. All rights reserved.</p>
          <p data-id="element-91">Made with ♥ in Singapore</p>
        </div>
      </div>
    </footer>;
}